<template>
  <div
    v-if="item"
    class="appo__pinned-item"
  >
    <div class="appo__pinned-item__container">
      <div
        ref="carousel"
        class="appo__pinned-item__carousel-container"
      >
        <div
          class="appo__pinned-item__carousel"
        >
          <template v-for="image in item.images">
            <div
              :key="`image_${image.display_image}`"
              class="appo__pinned-item__img-container"
            >
              <img
                class="appo__pinned-item__img"
                :src="`${image.display_image.split('?')[0]}?w=420&h=572`"
              >
            </div>
          </template>
        </div>
      </div>
      <base-icon
        v-if="actionsAllowed"
        icon="cancel"
        class="appo__pinned-item__button"
        @click="$emit('close')"
      />
      <base-icon
        v-if="item.images.length > 1 && current < item.images.length - 1 && actionsAllowed"
        icon="product-arrow-right"
        class="appo__pinned-item__arrow appo__pinned-item__arrow--right"
        @click="onArrowClicked('left')"
      />
      <base-icon
        v-if="current !== 0 && actionsAllowed"
        icon="product-arrow-left"
        class="appo__pinned-item__arrow appo__pinned-item__arrow--left"
        @click="onArrowClicked('right')"
      />
      <div
        v-if="item"
        class="appo__pinned-item__brand"
      >
        <base-text
          medium
          size="m"
        >
          {{ item.brand.name }}
        </base-text>
        <base-text
          medium
          size="m"
        >
          {{ item.title }}
        </base-text>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VideoProductDetail',
  props: {
    actionsAllowed: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => {},
    },
    offset: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      current: 0,
    };
  },
  watch: {
    current() {
      this.doScroll();
    },
  },
  mounted() {
    this.current = this.offset;
    this.doScroll();
    window.addEventListener('resize', this.doScroll);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.doScroll);
  },
  methods: {
    doScroll() {
      const { carousel } = this.$refs;
      const thumbSize = carousel.querySelector('img').width; // 210?
      carousel.scroll({
        left: thumbSize * this.current,
        top: 0,
        behavior: 'smooth',
      });
    },
    /** Also called from outside via ref */
    scroll(direction) {
      if (direction === 'left') {
        this.current += 1;
        this.current = (this.current > this.item.images.length) ? this.item.images.length : this.current;
      } else {
        this.current -= 1;
        this.current = (this.current < 0) ? 0 : this.current;
      }
    },
    onArrowClicked(direction) {
      this.scroll(direction);
      this.$emit('scroll', direction);
    },
  },
};
</script>

<style lang="scss" scoped>
$breakpoint-1: 769px;
.appo{
    &__pinned-item{
    position: absolute;
    top: 1rem;
    left: 1rem;
    right: 1rem;
    min-height: 330px;
    bottom: 300px;
    z-index: 100;
    border-radius: 15px;
    background-color: white;
    padding: 1rem;
    display: none;
    @media (min-width: $breakpoint-1) {
      display: block;
      bottom: inherit;
      right: inherit;
    }
    &__container{
      position: relative;
    }
    &__button{
      position: absolute;
      right: 0;
      top: 0;
      width: 20px;
      height: 20px;
      transition: opacity 0.2s;
      @media (min-width: $breakpoint-1) {
        opacity: 0;
      }
    }
    &:hover &__button{
      opacity: 0.5 !important;
    }
    &__img-container{
      min-width: 100%;
      border-right: solid 1px white;
      position: relative;
    }
    &__img {
      width: 100%;
      // height: 270px;
      max-height: 300px;
      object-fit: contain;
      pointer-events: none;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      @media (min-width: $breakpoint-1) {
        width: 210px;
        height: 286px;
      }
    }
    &__arrow {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        cursor: pointer;
        &--left{
            left: -15px;
        }
        &--right{
            right: -15px;
        }
    }
    &__brand{
        line-height: 1.1;
        text-align: center;
        display: none;
        @media (min-width: $breakpoint-1) {
          display: block;
          max-width: 200px;
        }
    }

    &__carousel{
      display: flex;
    }
    &__carousel-container{
      // height: 270px;
      height: 300px;
      width: 100%;
      overflow: hidden;
      // overflow-x: scroll;
      @media (min-width: $breakpoint-1) {
        overflow: hidden;
        width: 210px;
        height: 286px;
      }
    }
  }
}
</style>
